import { text_to_slug } from "../../../util/methods"

$(document).on("turbolinks:load", function () {
  // Download files destroy capability
  $(document).on("click", ".js-reset-download", function () {
    var $this = $(this)
    var $parent = $this.closest(".js-download-wrapper")
    $parent.hide()
    $parent
      .find(".js-download-destroy-target")
      .val($parent.data("product-download"))
  })

  /* Datepicker */
  $(".js-product-published_at").flatpickr({
    enableTime: true,
    minuteIncrement: 30,
    onChange: function () {
      $("#product_published_at").val($("#published_at").val())
    },
  })

  $(".flatpickr-minute").val("00")
  $("#product_published_at").val($("#published_at").val())

  sync_support_periods_visibility()
})

function sync_support_periods_visibility() {
  var $toggle = $("#product_support_periods_enabled")
  if (!$toggle.length) return
  toggle_conditional_field(
    "support-periods",
    $toggle.is(":checked") ? "show" : "hide"
  )
}

function toggle_conditional_field(type, action) {
  if (action === "hide") {
    $('div[data-conditional-hide="' + type + '"]').hide()
  } else {
    $('div[data-conditional-hide="' + type + '"]').show()
  }
}

function loadingMessages() {
  var type = $("body").attr("class")
  var text

  if (type === "layout-products-edit") {
    text = "Updating product"
  } else if (
    type === "layout-products-create" ||
    type === "layout-products-new"
  ) {
    text = "Creating product"
  } else if (type === "layout-vendor_emails-new") {
    text = "Creating email"
  } else if (type === "layout-vendor_emails-edit") {
    text = "Updating email"
  } else {
    text = "Saving"
  }

  $("body")
    .addClass("loading")
    .prepend('<div class="loading-messages">' + text + "...</div>")
}

// sluggify product title
$(document)
  .on("keyup", "#product_title", function () {
    if (window.location.pathname === "/creator/products/new") {
      $("#product_slug")
        .val(text_to_slug($(this).val()))
        .trigger("input")
    }
  })
  .on(
    "keypress",
    "#product_slug, #user_info_attributes_shop_slug",
    function (e) {
      if (
        e.which === 32 ||
        (e.which < 48 && e.which !== 45) ||
        (e.which > 57 && e.which < 65) ||
        (e.which > 90 && e.which < 97) ||
        e.which > 122
      ) {
        return false
      }
    }
  )
  .off("click", "a[data-save-clone]")
  .on("click", "a[data-save-clone]", function (e) {
    e.preventDefault()

    var action_id = $(this)
      .closest(".js-form-wrap")
      .find(".simple_form")
      .attr("ID")
    $("#error_explanation").remove()
    loadingMessages()
    setTimeout(function () {
      $("#" + action_id)[0].submit()
    }, 100)
  })
  .on("change", "#ready_for_review", function () {
    var $box = $(".js-data-box, .sticky-box")
    var trusted = $box.attr("data-box-trusted")
    var submit = $("a[data-save-clone]")
    var val = trusted === "true" ? "Schedule & Publish" : "Submit for Review"

    if ($(this).is(":checked")) {
      submit.removeClass("btn-primary").addClass("btn-danger").text(val)
      $(".simple_form").find("#submit_for_review").val("true")
    } else {
      submit
        .removeClass("btn-danger")
        .addClass("btn-primary")
        .text("Save Draft")
      $(".simple_form").find("#submit_for_review").val("")
    }
  })
  .on(
    "change",
    ".product_category_models, .product_category_surfacing",
    function () {
      if ($(this).is(":checked")) {
        toggle_conditional_field("misc-data", "show")
      } else {
        toggle_conditional_field("misc-data", "hide")
      }
    }
  )
  .on("change", "#product_support_periods_enabled", function () {
    sync_support_periods_visibility()
  })
  .on("cocoon:after-insert", function () {
    sync_support_periods_visibility()
  })
  .on("change", ".product_category_render-setups", function () {
    if ($(this).is(":checked")) {
      $(".radio_buttons.product_info_license")
        .find("label")
        .not('label[for="product_info_attributes_license_gpl"]')
        .hide()
    } else {
      $(".radio_buttons.product_info_license")
        .find("label")
        .not('label[for="product_info_attributes_license_gpl"]')
        .show()
    }
  })
